// eslint-disable-next-line no-unused-vars
import React, { memo, useEffect, useState } from 'react';
import { useContextSelector } from 'use-context-selector';

import ModalManager from 'Containers/ModalManager/ModalManager';
import CrossSalesPopupComponent from 'Components/Products/CrossSalesPopup';
import { defaultModalsState, ModalsContext } from 'Contexts/ModalsContext';
import useCart from 'Hooks/useCart';
import useRouter from 'Hooks/useRouter';

const CrossSalesPopup = memo(() => {
  const { modalData, resetModal } = useContextSelector(ModalsContext, data => ({
    modalData: data.modalState[defaultModalsState.CROSS_SALES.key],
    resetModal: () => data.resetModal(defaultModalsState.CROSS_SALES.key)
  }));
  const { data: { items }, updateProduct } = useCart();
  const [loading, setLoading] = useState(false);
  const { pathname } = useRouter();

  const handleOnAddToCart = async product => {
    const existingProduct = items.find(item => (
      item.productId === product.id
      && !item.promotion
    ));
    const payload = {
      ...product,
      quantity: Math.min(product.stockValue, product.minQuantity)
    };
    if (existingProduct) {
      payload.quantity = Math.min(product.stockValue, existingProduct.quantity + product.minQuantity || 1);
    }
    try {
      setLoading(product.id);
      await updateProduct(payload);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (modalData.state.open) {
      resetModal();
    }
  }, [pathname]);

  useEffect(() => resetModal, []);

  return (
    <ModalManager open={ modalData.state.open }>
      <CrossSalesPopupComponent
        open={ modalData.state.open }
        product={ modalData.state.product || {} }
        products={ modalData.state.products || [] }
        onClose={ resetModal }
        onAddToCart={ handleOnAddToCart }
        addToCartLoading={ loading }
      />
    </ModalManager>
  );
});

export default CrossSalesPopup;
